if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.form.querySelector('[name=id]').disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');
                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData(this.form);
                if (this.cart) {
                    formData.append(
                        'sections',
                        this.cart.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    this.cart.setActiveElement(document.activeElement);
                }
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButton.querySelector('span').classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response);
                                    });
                                }, { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove('loading');
                        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                    });
            }

            handleErrorMessage(errorMessage = false) {
                if (this.hideErrors) return;

                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}




// add to cart
const $sample_atc_submit_event = async function($form_data) {
    const $sample_addtocart_result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify($form_data),
    });
    const $atc_success_result = await $sample_addtocart_result.json();
    console.log("$atc_success_result", $form_data);
    if ($atc_success_result.items) {
        if (
            document.querySelector("cart-drawer") &&
            document.querySelector("cart-drawer").classList.contains("is-empty")
        )
            document.querySelector("cart-drawer").classList.remove("is-empty");
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
            document.body.addEventListener(
                "modalClosed",
                () => {
                    setTimeout(() => {
                        document
                            .querySelector("cart-drawer")
                            .renderContents($atc_success_result);
                    });
                }, { once: true }
            );
            quickAddModal.hide(true);
        } else {
            document.querySelector("cart-drawer").renderContents($atc_success_result);
        }
    } else {
        console.error($atc_success_result);
    }
};
$(document).on("click", ".product-multi-form__submit", function(e) {
    e.preventDefault(),
        e.stopImmediatePropagation();
    let sample_product_atc_array = [];

    $(this).parents(".product__info-wrapper").find(".form-check-input:checked").each(function() {
        var variant_id = $(this).val();
        var qty = $(this).attr("Qty");
        var custom_text = $('#custom-text').val();
        var product_custom_text = $('#product-custom-text').val();
        if ($(".block__main-product-usb .block__product-details").length) {
            var data_main_product = $(this).parents(".block__product-details").attr("data_main_product");                
            sample_product_atc_array.push({
                id: variant_id,
                quantity: qty,
                properties: { 
                    "Note": data_main_product,
                    "Project Name":custom_text,
                    "_USB-Enrollment-title":product_custom_text
                }
            });
        } else {
            sample_product_atc_array.push({
                id: variant_id,
                quantity: qty,
                properties: { 
                    "Note": data_main_product,
                    "Project Name":custom_text,
                    "_USB-Enrollment-title":product_custom_text
                }
            });
        }
    });

    console.log("sample_product_atc_array", sample_product_atc_array)

    let sample_product_atc_formData = {
        items: sample_product_atc_array,
        sections_url: window.location.pathname,
        sections: document
            .querySelector("cart-drawer")
            .getSectionsToRender()
            .map((section) => section.id),
    };
    $sample_atc_submit_event(sample_product_atc_formData);
});